import { supabase } from '@/lib/supabase';

export const getDocumentPreviewUrl = async (path: string): Promise<string> => {
  const { data, error } = await supabase.storage
    .from('documents')
    .createSignedUrl(path, 3600);

  if (error) {
    throw error;
  }

  if (!data?.signedUrl) {
    throw new Error('No signed URL received from storage');
  }

  return data.signedUrl;
};
